module.exports = __webpack_public_path__ + "static/media/movie.a7e555e9.png";